
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';
import { ROLES } from '../utils/constants'
import { checkAccessRights } from '../utils/functions/accessRight'
// Define a service using a base URL and expected endpoints

const USER = process.env.REACT_APP_API_URL
const ADMIN = process.env.REACT_APP_API_URL_admin

const baseQuery = fetchBaseQuery({
    // baseUrl: `${process.env.REACT_APP_API_URL_admin}/matchstatement`,
   baseUrl: `${checkAccessRights(ROLES.ADMIN_ROLE) || checkAccessRights(ROLES.SUPER_ADMIN_ROLE) ? ADMIN : USER}`,
    prepareHeaders: (headers) => {
      const token = getStorage('token');
      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
  
      return headers;
    },
  });

export const csatApi = createApi({
  reducerPath: 'csatApi',
  baseQuery,
  endpoints: (builder) => ({
    getCsat: builder.query({
        query: () => '/csat/',
    }),
    postCsat: builder.mutation({
      query: () => ({ url: '/csat/', method: 'POST' }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCsatQuery,usePostCsatMutation } = csatApi;
